import type { GameState, TeamId } from '../../types/game';
import { TEAM_COLORS, TEAM_NAMES } from '../../types/game';
import { useSound } from '../../contexts/SoundContext';
import clsx from 'clsx';

interface AdminHeaderProps {
  game: GameState;
  connected: boolean;
  onReset: () => void;
  questionsPerRound: number;
}

export const AdminHeader = ({ game, connected, onReset, questionsPerRound }: AdminHeaderProps) => {
  const sound = useSound();

  return (
    <header className="bg-bg-surface border-b-2 border-purple-600 px-6 py-3 mb-4 shadow-[0_4px_0_purple]">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-6">
          <img src="/LogoC.svg" alt="Logo" className="w-12 h-12" />
          <div className="flex flex-col">
            <span className="text-xl font-bold">CLA - QuizShow</span>
            <span className="text-md font-medium">Moderador</span>
          </div>


          <div className="flex items-center gap-2">
            {game.roundPhase === 'steal' && (
              <span className="status-badge status-badge-warning animate-pulse">
                ROBO
              </span>
            )}
          </div>

          <div className="flex flex-col border-l-2 border-white/10 pl-6 ml-2">
            <span className="text-sm font-bold text-white/90">
              Ronda {Math.max(1, game.round)} &bull; Grado {game.grade}°
            </span>
            <span className="text-xs font-semibold text-warning">
              Preguntas: {game.questionsThisRound} / {questionsPerRound}
            </span>
          </div>

          {(() => {
            const currentTurnTeam = game.teamOrder?.[game.currentTurnIndex ?? 0] as TeamId | undefined;
            const hasWinner = !!game.winner;
            const isRoundEnd = game.roundPhase === 'round_end' && game.status === 'round_end';
            
            if (currentTurnTeam && game.currentQuestion && !isRoundEnd && !hasWinner) {
              const color = TEAM_COLORS[currentTurnTeam];
              return (
                <div 
                  className="flex items-center gap-2 px-3 py-1 rounded-lg border-2"
                  style={{ borderColor: color.bg, background: `${color.bg}15` }}
                >
                  <div className="w-6 h-6 rounded flex items-center justify-center font-black text-black text-xs" style={{ background: color.bg }}>
                    {currentTurnTeam}
                  </div>
                  <div className="text-xs font-black uppercase" style={{ color: color.bg }}>
                    {TEAM_NAMES[currentTurnTeam]}
                  </div>
                </div>
              );
            }
            return null;
          })()}
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={() => sound.setEnabled(!sound.enabled)}
            className="btn btn-sm btn-outline"
            title={sound.enabled ? 'Silenciar sonidos' : 'Activar sonidos'}
          >
            {sound.enabled ? '🔊' : '🔇'}
          </button>

          <div className={clsx(
            'conn-dot',
            connected ? 'conn-dot--connected' : 'conn-dot--disconnected'
          )} />

          <button
            onClick={onReset}
            className="btn btn-sm btn-outline-danger"
          >
            Reiniciar
          </button>
        </div>
      </div>
    </header>
  );
};
